import {defineMessage} from 'react-intl';
import {cancel} from '@sail/icons/react/Icon';
import {HeaderButton, Placement} from './HeaderButton';
import {useWidgetControls, useWidgetVisibility} from '../useWidget';
import {useAnalytics} from '../../AnalyticsProvider';

const label = defineMessage({
  id: 'conversations_ui.widget.header.closeButton.label',
  description: 'Label used for the header button that closes the widget.',
  defaultMessage: 'Close',
});

type Props = {
  disabled?: boolean;
  tooltipEnabled?: boolean;
  color?: string;
  hoverColor?: string;
};

export function CloseButton({
  disabled = false,
  tooltipEnabled = true,
  color,
  hoverColor,
}: Props) {
  const {visibility} = useWidgetVisibility();
  const {close} = useWidgetControls();
  const analytics = useAnalytics();

  let placement: Placement;
  if (visibility === 'open') {
    placement = 'bottom left';
  } else {
    placement = 'left';
  }

  return (
    <HeaderButton
      testId="conversations-widget-header-close-button"
      icon={cancel}
      label={label}
      onPress={() => {
        analytics.action('close_button_clicked');
        close();
      }}
      tooltipPlacement={placement}
      disabled={disabled}
      color={color}
      hoverColor={hoverColor}
      tooltipEnabled={tooltipEnabled}
    />
  );
}
